import React, { useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import StyledModal from "../../Modals/StyledModal/StyledModal";
import PrimaryTextField from "../../Inputs/PrimaryTextField/PrimaryTextField";
import PrimaryButton from "../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../Buttons/SecondaryButton/SecondaryButton";
import { handleAltEnter } from "../../../utils/keyboardShortcutHelpers";

export default function CarrierSearchCreateModal({
  handleSave,
  isLoading
}) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  const handleOpen = () => {
    setName("");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveSearch = () => {
    handleSave(name);
    handleClose();
  };
  
  return (
    <Box onKeyDown={(e) => handleAltEnter(e, (isLoading || !name), handleSaveSearch)}>
      <Box>
        <SecondaryButton
          label="Save as"
          onClick={handleOpen}
          isLoading={isLoading}
          size="small"
        />
      </Box>
      <StyledModal
        label="Save search as"
        title="Save search as"
        open={open}
        handleClose={handleClose}
      >
        <Box sx={{ display: "flex", marginTop: "20px" }}>
          <PrimaryTextField
            id="tab-name"
            label="Name this search"
            onChange={setName}
            value={name}
            maxLength="10"
          />
          <Box sx={{ display: "flex", margin: "0 0 0 20px" }}>
            <Box sx={{ marginLeft: "auto", padding: "0 10px 5px 5px" }}>
              <SecondaryButton
                label="Cancel"
                onClick={handleClose}
                disabled={isLoading}
              />
            </Box>
            <Box sx={{ padding: "0 0 5px 5px" }}>
              <PrimaryButton
                label="Save"
                width="50px"
                onClick={handleSaveSearch}
                isLoading={isLoading}
                disabled={isLoading || !name}
              />
            </Box>
          </Box>
        </Box>
      </StyledModal>
    </Box>
  );
}

CarrierSearchCreateModal.propTypes = {
  handleSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired
};